export default {
     validateModification: function (file) {
        return new Promise((resolve, reject) => {
            if(file == null) resolve();

            var fr = new FileReader();  
            fr.readAsText(file);

            fr.onload = () => {resolve()};
            fr.onerror = () => {reject(Error(file.name))};
          });
    }
}